import { useCallback, useMemo, useState } from 'react'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { getPopularBanksData } from '../utils/getPopularBanksData'
import { useFetchBanks } from './useFetchBanks'

export const usePopularBanksSearch = (popularBanksListLength?: number) => {
  const [prefilledSearch, setPrefilledSearch] = useState('')
  const { organization } = useUserOrganization()
  const { banks } = useFetchBanks()

  const popularBanks = useMemo(() => {
    if (!organization?.countryId || banks.length === 0) {
      return []
    }

    return getPopularBanksData(organization.countryId, banks, popularBanksListLength)
  }, [banks, organization?.countryId, popularBanksListLength])

  const shouldShowPopularBanksList = popularBanks.length > 0

  const handleSearchPrefill = useCallback(
    (bankName: string) => {
      if (prefilledSearch === bankName) {
        setPrefilledSearch('')
      } else {
        setPrefilledSearch(bankName)
      }
    },
    [prefilledSearch],
  )

  const handleClear = useCallback(() => {
    setPrefilledSearch('')
  }, [])

  return {
    prefilledSearch,
    popularBanks,
    shouldShowPopularBanksList,
    handleSearchPrefill,
    handleClear,
  }
}
